export default __webpack_public_path__ + "b413cf44ef5ae08d933f5ab7af34fa5d.mp3";